module.exports = __webpack_public_path__ + "img/titleSet_sp.eae5b2d1.svg";